import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import { combineReducers } from 'redux';
import ConcertHighlightsSlider from '../components/ConcertHighlightsSlider'
import ConcertNewsSlider from '../components/ConcertNewsSlider'
import ConcertTipsSlider from '../components/ConcertTipsSlider'
import RafflesSlider from '../components/RafflesSlider'
import { ShareModalConnected } from '../components/Share';
import RelatedConcerts from '../components/RelatedConcerts'
import LatestBlogPosts from '../components/LatestBlogPosts'
import NewsletterSubscribtionWidget from '../components/NewsletterSubscribtionWidget'

// Actions
const SET_SHARE = "SET_SHARE";

// Reducer
function share_modal(state = {}, action) {
  switch(action.type) {
    case SET_SHARE:
      return action.share_modal;
      
    default:
      return state;      
  }
}

// Store
const App = combineReducers({ share_modal });
const store = createStore(App, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());


// Render each connected component separatly. 
// Both components share the same state.
ReactDOM.render(
    <Provider store={ store }>
        <ShareModalConnected />
    </Provider>,
    document.getElementById('share_modal'),
);

const concertHighlightsSlider = document.getElementById('concertHighlightsSlider')

  if (concertHighlightsSlider) {
    const title = concertHighlightsSlider.getAttribute('title')

    ReactDOM.render(
      <Provider store={ store }>
        <ConcertHighlightsSlider title={title}/>
      </Provider>,
      document.getElementById('concertHighlightsSlider'),
    )
  }


const concertNewsSlider = document.getElementById('concertNewsSlider')

if (concertNewsSlider) {
  ReactDOM.render(
    <Provider store={ store }>
      <ConcertNewsSlider />
    </Provider>,
    document.getElementById('concertNewsSlider'),
  )
}


const concertTipsSlider = document.getElementById('concertTipsSlider')

if (concertTipsSlider) {
  ReactDOM.render(
    <Provider store={ store }>
      <ConcertTipsSlider />
    </Provider>,
    document.getElementById('concertTipsSlider'),
  )
}

const rafflesSlider = document.getElementById('rafflesSlider')

if (rafflesSlider) {
  const title = rafflesSlider.getAttribute('title')
  const linkText = rafflesSlider.getAttribute('linkText')
  const linkUrl = rafflesSlider.getAttribute('linkUrl')

  ReactDOM.render(
    <Provider store={ store }>
      <RafflesSlider title={title} linkText={linkText} linkUrl={linkUrl} />
    </Provider>,
    document.getElementById('rafflesSlider'),
  )
}

const newsletterSubscribtionWidget__mobile = document.getElementById('newsletterSubscribtionWidget__mobile')

  if (newsletterSubscribtionWidget__mobile) {  
    ReactDOM.render(
      <NewsletterSubscribtionWidget />,
      document.getElementById('newsletterSubscribtionWidget__mobile'),
    )
  }

  const newsletterSubscribtionWidget__desktop = document.getElementById('newsletterSubscribtionWidget__desktop')

  if (newsletterSubscribtionWidget__desktop) {  
    ReactDOM.render(
      <NewsletterSubscribtionWidget />,
      document.getElementById('newsletterSubscribtionWidget__desktop'),
    )
  }

  const newsletterSubscribtionWidget2 = document.getElementById('newsletterSubscribtionWidget2')

  if (newsletterSubscribtionWidget2) {  
    ReactDOM.render(
      <NewsletterSubscribtionWidget />,
      document.getElementById('newsletterSubscribtionWidget2'),
    )
  }

document.addEventListener('DOMContentLoaded', () => {
  const relatedConcerts = document.getElementById('relatedConcerts')

  if (relatedConcerts) {
    const artist = relatedConcerts.getAttribute('artist')
    const title = relatedConcerts.getAttribute('title')

    ReactDOM.render(
      <RelatedConcerts title={title} artist={artist} />,
      document.getElementById('relatedConcerts'),
    )
  }

})

document.addEventListener('DOMContentLoaded', () => {
  const latestBlogPosts = document.getElementById('latestBlogPosts')

  if (latestBlogPosts) {  
    ReactDOM.render(
      <LatestBlogPosts />,
      document.getElementById('latestBlogPosts'),
    )
  }

})